module.exports = __webpack_public_path__ + "img/tarjeta-de-credito.8b0ece30.png";